<template>
  <div class="addressManage-page">
    <div style="font-weight: bold;margin-bottom: 20px;">ETH地址nonce管理</div>

    <fieldset>
      <legend>热钱包地址</legend>
      <div class="hotbox" v-for="(item,index) in hotUrl" :key="item">
        <p>
          当前热钱包地址: <strong>{{ item }}</strong>
        </p>
        <div>
          nonce :<el-input
            v-model="hotnonce[index]"
            placeholder="请输入nonce "
          ></el-input>
          gasPrice :<el-input
            v-model="hotgasprice[index]"
            placeholder="请输入gasPrice "
          ></el-input>
          <el-button
            type="primary"
            @click="executeE(interfaceArr[0].execute, {nonce:hotnonce[index],gasPrice:hotgasprice[index]}, 'hot',item,index)"
            >执行</el-button
          >
        </div>
      </div>
    </fieldset>

    <fieldset>
      <legend>owner地址</legend>
      <p>
        当前owner地址: <strong>{{ ownerUrl }}</strong>
      </p>
      <div>
        nonce :<el-input
          v-model="owner.nonce"
          placeholder="请输入nonce "
        ></el-input>
        gasPrice :<el-input
          v-model="owner.gasPrice"
          placeholder="请输入gasPrice "
        ></el-input>
        <el-button
          type="primary"
          @click="executeE(interfaceArr[1].execute, owner, 'owner')"
          >执行</el-button
        >
      </div>
    </fieldset>

    <fieldset>
      <legend>手续费地址</legend>
      <p>
        当前手续费地址: <strong>{{ serviceUrl }}</strong>
      </p>
      <div>
        nonce :<el-input
          v-model="service.nonce"
          placeholder="请输入nonce "
        ></el-input>
        gasPrice :<el-input
          v-model="service.gasPrice"
          placeholder="请输入gasPrice "
        ></el-input>
        <el-button
          type="primary"
          @click="executeE(interfaceArr[2].execute, service, 'service')"
          >执行</el-button
        >
      </div>
    </fieldset>
  </div>
</template>

<script>
import api from './api';
export default {
  name: 'AddressManage',
  data() {
    return {
      ceshi:['11111','222222','333333'],
      hotnonce:[],
      hotgasprice:[],
      hot: {},
      owner: {},
      service: {},
      hotUrl: [],
      ownerUrl: '',
      serviceUrl: '',
      interfaceArr: [
        {
          get: '/admin/eth/withdrawAddr',
          execute: '/admin/eth/nonce/rush/withdaw',
          desc: '提现地址',
          key: 'hot'
        },
        {
          get: '/admin/eth/sweepAddr',
          execute: '/admin/eth/nonce/rush/sweep',
          desc: 'owner地址',
          key: 'owner'
        },
        {
          get: '/admin/eth/feeAddr',
          execute: '/admin/eth/nonce/rush/fee',
          desc: '手续费地址',
          key: 'service'
        }
      ]
    };
  },
  methods: {
    // getAddress() {
    //   let a1 = api.queryWithdrawAddr();
    //   let a2 = api.querySweepAddr();
    //   let a3 = api.queryFeeAddr();
    //   Promise.allSettled([a1, a2, a3]).then(res => {
    //     console.log('res', res);
    //   });
    // },

    getWithdrawAddr() {
      api.queryWithdrawAddr(this.interfaceArr[0].get).then(res => {
        console.log(res)
        if (!res.code) {
          if (res.data) {
            this.hotUrl = res.data;
          } else {
            this.hotUrl = '返回值为null';
          }
        } else {
          this.hotUrl = res.msg;
        }
      });
    },
    getSweepAddr() {
      api.querySweepAddr(this.interfaceArr[1].get).then(res => {
        if (!res.code) {
          if (res.data) {
            this.ownerUrl = res.data;
          } else {
            this.ownerUrl = '返回值为null';
          }
        } else {
          this.ownerUrl = res.msg;
        }
      });
    },

    getFeeAddr() {
      api.queryFeeAddr(this.interfaceArr[2].get).then(res => {
        if (!res.code) {
          if (res.data) {
            this.serviceUrl = res.data;
          } else {
            this.serviceUrl = '返回值为null';
          }
        } else {
          this.serviceUrl = res.msg;
        }
      });
    },
    pageInit() {
      this.getWithdrawAddr();
      this.getSweepAddr();
      this.getFeeAddr();
    },

    executeE(url, data, formName,hoturl) {
      this[formName] = {};
      if(formName === 'hot'){
        data.withdrawAddress=hoturl
      }
      api.executeE({ url, data }).then(res => {
        if (!res.code) {
          this[formName] = {};
          this.$message.success(`执行成功,结果为:${res.data}`);
        } else {
          this.$message.error(res.msg);
        }
      });
    }
  },
  created() {
    this.pageInit();
  }
};
</script>

<style lang="less" scoped>
.addressManage-page {
  fieldset {
    border-color: #76e6898a;
    margin-bottom: 20px;
    padding: 20px 0 20px 20px;
    legend {
      color: #409eff;
      font-size: 16px;
      font-weight: bold;
    }
    
    .el-input {
      width: 200px;
      padding-right: 30px;
      padding-left: 6px;
    }
  }
}
.hotbox{
  margin-top:20px;
    }
</style>
